import React, {useContext} from 'react';
import { useState } from 'react';
import { set } from 'immutadot';
import { useCallback } from 'react';
const ModuleHistoryContext = React.createContext(null);
const ModuleHistoryDataContext = React.createContext(null);

type RecordModuleHistoryValue = (name:string)=>void;
type ModuleHistoryData = (name:string)=>string;

export function useRecordModuleHistory() {
    return useContext<RecordModuleHistoryValue>(ModuleHistoryContext);
}

export const useModuleHistoryData = ()=>{
    return useContext<ModuleHistoryData>(ModuleHistoryDataContext);
}

export const ModuleHistoryContextProvider = ({ children }) => {
    const [moduleHistory,setModuleHistory] = useState({});
    const recordModuleHistory = useCallback((name)=>{
        const val = location.pathname + location.search;
        setModuleHistory((oldHistory) => set(oldHistory, name.replace('/',''),val));
    },[setModuleHistory]);
    const getModuleHistory = useCallback((name)=> {
        console.log('MHS get',name,'from',moduleHistory);
        return moduleHistory[name.replace('/','')];
    },[moduleHistory]);
    console.log('histories are',moduleHistory);
    return <ModuleHistoryContext.Provider value={recordModuleHistory}>
        <ModuleHistoryDataContext.Provider value={getModuleHistory}>
                        {children}
        </ModuleHistoryDataContext.Provider>
    </ModuleHistoryContext.Provider>;
};